export default "__VITE_ASSET__CSbdSt1L__"